<template>
    <v-list-item>
        <v-list-item-content>
            <v-auto-img :src="image" :height="cardHeight/2" contain/>
            <v-list-item-title>
                {{title}}
            </v-list-item-title>

            {{shortDescription}}
        </v-list-item-content>
    </v-list-item>
</template>

<script>
export default {
    name: 'zoezi-product-card',

    zoezi: {
        title: 'Product card',
        icon: 'mdi-card-text'
    },

    props: {
        title: {
            title: 'Title',
            type: String
        },
        image: {
            title: 'Image',
            type: String,
            fulltype: 'image'
        },
        height: {
            title: 'Height (px)',
            type: Number
        },
        shortDescription: {
            title: 'Short description',
            type: String
        }
    },

    computed: {
        cardHeight() {
            let findParent = function(x) {
                if (!x) {
                    return;
                }
                if (x.$options.name == 'zoezi-product-list') {
                    return x;
                }

                return findParent(x.$parent);
            };

            if (this.height) {
                return this.height;
            }

            let parent = findParent(this);
            return parent ? parent.cardHeight : 200;
        }
    }
}
</script>
